import BaseComponent from 'foundation/base-component';
import eventBus from '../../../general/js/event-bus';

export default class VenueHero extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.venueHeroSticky = this.refs.venueHeroSticky;

        this.visibleHandler = this.visibleHandler.bind(this);
        this.hiddenHandler = this.hiddenHandler.bind(this);

        this.init();
    }

    init() {
        eventBus.emit('venue-hero-init', {
            venueHeroStickyRef: this.venueHeroSticky
        });

        this.createObserver();
    }

    createObserver() {
        const observer = new IntersectionObserver((observables) => {
            const observable = observables[0];

            if (observable.intersectionRatio > 0) {
                this.hiddenHandler();
            } else {
                this.visibleHandler();
            }
        });

        observer.observe(this.element);
    }

    hiddenHandler() {
        this.venueHeroSticky.classList.remove('is-visible');
    }

    visibleHandler() {
        this.venueHeroSticky.classList.add('is-visible');
    }
}
